import * as React from 'react';
import type { HubListContextMenuProperties } from '../../../shared';
import { default as HubListContextMenuAsync } from './hubListContextMenuAsync';

export const renderHubListContextMenu = (
    hubListCotextMenuProperties: HubListContextMenuProperties
): JSX.Element => {
    return <HubListContextMenuAsync {...hubListCotextMenuProperties} />;
};
